import React, { useState } from 'react'
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse } from '@mui/material'
import { Link } from 'react-router-dom'

const NestedItem = ({ keyName, open, label, icon, list }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = () => setIsOpen((prev) => !prev)

  const listItemStyles = {
    display: 'block',
    color: 'inherit',
    textDecoration: 'none',
    '&:visited': { color: 'inherit' },
    my: 0
  }

  const listItemButtonStyles = {
    minHeight: 40,
    justifyContent: open ? 'initial' : 'center',
    px: 2.5
  }

  const listItemIconStyles = {
    minWidth: 0,
    mr: open ? 3 : 'auto',
    justifyContent: 'center'
  }

  const nestedListItemButtonStyles = {
    ...listItemButtonStyles,
    minHeight: 36
  }

  return (
    <>
      <ListItem key={keyName} disablePadding sx={listItemStyles} onClick={handleToggle}>
        <ListItemButton sx={listItemButtonStyles}>
          <ListItemIcon sx={listItemIconStyles}>{icon}</ListItemIcon>
          <ListItemText primary={label} sx={{ opacity: open ? 1 : 0 }} />
        </ListItemButton>
      </ListItem>

      <Collapse in={isOpen} timeout='auto' unmountOnExit>
        <List disablePadding>
          {list.map(({ keyName: nestedKey, label: nestedLabel, to, icon: nestedIcon }) => (
            <ListItem key={nestedKey} component={Link} to={to} disablePadding sx={listItemStyles}>
              <ListItemButton sx={nestedListItemButtonStyles}>
                <ListItemIcon sx={listItemIconStyles}>{nestedIcon}</ListItemIcon>
                <ListItemText primary={nestedLabel} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Collapse>
    </>
  )
}

export default NestedItem
